module.exports = __webpack_public_path__ + "img/02—02—Device List > Carousel II.5bdf5778.jpg";